import { UseFormReturn } from "react-hook-form";

import { DateTimeInput } from "@/components/inputs/DateTimeInput";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@/components/ui/select";
import { TournamentLayoutMetadata } from "@/routes/tournament/TournamentLayoutDetailRoute";

export const TournamentMetadataForm = ({
    form,
    onSubmit,
}: {
    form: UseFormReturn<TournamentLayoutMetadata>;
    onSubmit: () => void;
}) => {
    return (
        <Form {...form}>
            <form
                className="w-full"
                onSubmit={ev => {
                    ev.preventDefault();
                    onSubmit();
                }}
            >
                <FormField
                    control={form.control}
                    name="name"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Name (internal)</FormLabel>
                            <FormControl>
                                <Input
                                    placeholder="For tournament xyz"
                                    autoComplete="off"
                                    {...field}
                                />
                            </FormControl>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="tournamentPhase"
                    render={({ field }) => (
                        <FormItem>
                            <FormLabel>Tournament Phase</FormLabel>
                            <FormControl>
                                <Select value={field.value} onValueChange={field.onChange}>
                                    <SelectTrigger>
                                        <SelectValue placeholder="Select phase" />
                                    </SelectTrigger>
                                    <SelectContent>
                                        <SelectItem value={"BEFORE"}>Before tournament</SelectItem>
                                        <SelectItem value={"DURING"}>During tournament</SelectItem>
                                        <SelectItem value={"AFTER"}>After tournament</SelectItem>
                                    </SelectContent>
                                </Select>
                            </FormControl>
                            <FormDescription>
                                Select which phase of the tournament this layout applies to
                            </FormDescription>
                            <FormMessage />
                        </FormItem>
                    )}
                />
                <FormField
                    control={form.control}
                    name="publishAt"
                    render={({ field }) => (
                        <FormItem>
                            <div className="my-2 flex items-center gap-2">
                                <Checkbox
                                    id="publish-checkbox"
                                    checked={field.value ? true : false}
                                    onCheckedChange={newVal =>
                                        field.onChange(newVal ? new Date().toISOString() : null)
                                    }
                                />
                                <label htmlFor="publish-checkbox">Publish</label>
                            </div>
                            {field.value && (
                                <div>
                                    <FormLabel>Publish at</FormLabel>
                                    <DateTimeInput
                                        value={field.value ? new Date(field.value) : null}
                                        onValue={startAt => field.onChange(startAt.toISOString())}
                                        className="w-full"
                                    />
                                    <Button
                                        type="button"
                                        variant="outline"
                                        onClick={() => field.onChange(new Date().toISOString())}
                                    >
                                        set to now
                                    </Button>
                                    <FormDescription>
                                        The layout will be published at the specified date
                                    </FormDescription>
                                </div>
                            )}
                            <FormMessage />
                        </FormItem>
                    )}
                />
            </form>
        </Form>
    );
};
